import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Grid,
  InputAdornment,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  clearAction,
  createGstThunk,
  updateGstThunk,
} from "store/reducers/product/productGstSlice";
import * as yup from "yup";

const validation = yup.object({
  HSNCODE: yup.string("Enter HSNCODE"),
  CGST: yup.string("Enter CGST"),
  SGST: yup.string("Enter SGST"),
  CESS: yup.string("Enter CESS"),
  product: yup.number("Enter product"),
});

const ProductGstCreate = ({
  product,
  gst = null,
  fullGrid = false,
  handleNext = null,
}) => {
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const formik = useFormik({
    initialValues: {
      HSNCODE: gst?.HSNCODE ?? "",
      CGST: gst?.CGST ?? 0.0,
      SGST: gst?.SGST ?? 0.0,
      CESS: gst?.CESS ?? 0.0,
      product: gst?.product ?? product,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      if (gst) {
        dispatch(
          updateGstThunk({
            id: gst.id,
            data,
          })
        );
      } else {
        dispatch(createGstThunk(data));
      }
    },
    validateOnChange: false,
  });

  const status = useSelector((state) => state.productGst.status);

  useEffect(() => {
    dispatch(clearAction());
  }, []);

  useEffect(() => {
    if (handleNext && status?.success === "created") {
      handleNext();
    }
  }, [status]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={1.5} paddingY={3}>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="HSN Code"
            variant="outlined"
            name="HSNCODE"
            fullWidth
            value={formik.values.HSNCODE}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.HSNCODE)}
            helperText={formik.errors.HSNCODE}
            autoComplete="new-password"
            required
            type="text"
          />
        </Grid>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="CGST"
            variant="outlined"
            name="CGST"
            fullWidth
            value={formik.values.CGST}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.CGST)}
            helperText={formik.errors.CGST}
            autoComplete="new-password"
            required
            type="number"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="SGST"
            variant="outlined"
            name="SGST"
            fullWidth
            value={formik.values.SGST}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.SGST)}
            helperText={formik.errors.SGST}
            autoComplete="new-password"
            required
            type="number"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="CESS"
            variant="outlined"
            name="CESS"
            fullWidth
            value={formik.values.CESS}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.CESS)}
            helperText={formik.errors.CESS}
            autoComplete="new-password"
            required
            type="number"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      {(status?.error === "create" || status?.error === "update") && (
        <Alert sx={{ my: 1 }} severity="error">
          Error occurred
        </Alert>
      )}

      {(status?.success === "create" || status?.success === "update") && (
        <Alert sx={{ my: 1 }} severity="success">
          Success
        </Alert>
      )}
      <LoadingButton
        loading={status?.loading === "create" || status?.loading === "update"}
        variant="contained"
        fullWidth={isFullWidth}
        type="submit"
        sx={{ paddingX: 10, marginTop: 1 }}
      >
        {gst ? "Update" : "Create"}
      </LoadingButton>
    </form>
  );
};

export default ProductGstCreate;
